module.exports = __webpack_public_path__ + "static/img/xj_img6.9654edd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj_img6.jpg
// module id = SDmt
// module chunks = 4